import React from 'react';
import { X } from 'lucide-react';

const Differentiation = () => {
  return (
    <section className="py-20 bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-normal text-black mb-6" style={{ fontFamily: "'DM Serif Display', serif", textShadow: 'none', WebkitFontSmoothing: 'antialiased' }}>
            Not Your Typical Recruiter
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" style={{ fontFamily: "'DM Serif Display', serif" }}>
            Clear boundaries create better outcomes.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* We Are Not */}
          <div className="bg-white border border-red-200 rounded-lg p-6">
            <h3 className="text-lg font-normal text-black mb-4 flex items-center">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mr-3">
                <X className="h-6 w-6 text-red-600" />
              </div>
              We Are Not
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <span className="text-red-600 mr-3 mt-0.5 text-sm">✗</span>
                <span className="text-gray-700 text-sm leading-relaxed">A multi-sector generalist recruiter</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-3 mt-0.5 text-sm">✗</span>
                <span className="text-gray-700 text-sm leading-relaxed">A CV forwarding service</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-3 mt-0.5 text-sm">✗</span>
                <span className="text-gray-700 text-sm leading-relaxed">A volume placement firm</span>
              </li>
              <li className="flex items-start">
                <span className="text-red-600 mr-3 mt-0.5 text-sm">✗</span>
                <span className="text-gray-700 text-sm leading-relaxed">A low-fee commission chaser</span>
              </li>
            </ul>
          </div>

          {/* We Are */}
          <div className="bg-white border border-[#FFD000] rounded-lg p-6">
            <h3 className="text-lg font-normal text-black mb-4 flex items-center">
              <div className="w-12 h-12 bg-[#FFD000]/10 rounded-lg flex items-center justify-center mr-3">
                <div className="h-6 w-6 bg-[#FFD000] rounded"></div>
              </div>
              We Are
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <span className="text-[#FFD000] mr-3 mt-0.5 text-sm">✓</span>
                <span className="text-gray-700 text-sm leading-relaxed">Hospitality-focused</span>
              </li>
              <li className="flex items-start">
                <span className="text-[#FFD000] mr-3 mt-0.5 text-sm">✓</span>
                <span className="text-gray-700 text-sm leading-relaxed">Selective</span>
              </li>
              <li className="flex items-start">
                <span className="text-[#FFD000] mr-3 mt-0.5 text-sm">✓</span>
                <span className="text-gray-700 text-sm leading-relaxed">Structured</span>
              </li>
              <li className="flex items-start">
                <span className="text-[#FFD000] mr-3 mt-0.5 text-sm">✓</span>
                <span className="text-gray-700 text-sm leading-relaxed">Founder-led</span>
              </li>
              <li className="flex items-start">
                <span className="text-[#FFD000] mr-3 mt-0.5 text-sm">✓</span>
                <span className="text-gray-700 text-sm leading-relaxed">Risk-aware</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 text-center bg-white border border-gray-200 rounded-lg p-6">
          <p className="text-base text-gray-800 mb-2">
            <span className="text-black font-semibold">We work with a limited number of clients at a time.</span>
          </p>
          <p className="text-gray-600 text-sm">
            Not every vacancy is accepted. Screening depth matters more than speed.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Differentiation;
